import { EMPTY_OBJECT, MARKET_ACCOUNT_LEDGER_EVENT, useSubscription, type LedgerEvent } from '@talos/kyoko';

interface UseMarketAccountLedgerEventsParams {
  filter?: MarketAccountLedgerEventsFilter;
  tag: string;
}

interface MarketAccountLedgerEventsFilter {
  MarketAccounts?: string[];
  Symbols?: string[];
  StartDate?: string;
  EndDate?: string;
}

export const useMarketAccountLedgerEvents = ({ filter = EMPTY_OBJECT, tag }: UseMarketAccountLedgerEventsParams) => {
  return useSubscription<LedgerEvent>({
    name: MARKET_ACCOUNT_LEDGER_EVENT,
    tag: `${tag}/useMarketAccountLedgerEvents`,
    ...filter,
  });
};
